// extracted by mini-css-extract-plugin
export var bigHeading = "bigHeading-module--big-heading--C0v72";